import { GAME_STEPS } from '@/src/constants';
import sendEventToCounters from '@/src/counterEvents';
import { useAppDispatch, useAppSelector } from '@/src/hooks';
import {
  currentGamePrevAnswerSelector,
  currentGameSkillsSelector,
} from '@/src/store/selectors/game';
import {
  removeLastAnswer,
  removeSkill,
  setCurrentStep,
} from '@/src/store/slices/gameSlice';
import { Dispatch, SetStateAction } from 'react';

type TProps = {
  setIsVisibleChoice: Dispatch<SetStateAction<boolean>>;
};

export const BackButton = ({ setIsVisibleChoice }: TProps) => {
  const dispatch = useAppDispatch();
  const prevAnswer = useAppSelector(currentGamePrevAnswerSelector);
  const skills = useAppSelector(currentGameSkillsSelector);
  const prevStepButtons = GAME_STEPS[prevAnswer].buttons;

  const handleClick = () => {
    dispatch(setCurrentStep(prevAnswer));
    dispatch(removeLastAnswer());

    prevStepButtons?.map(({ skill }) => {
      if (skill && skills.includes(skill)) {
        dispatch(removeSkill(skill));
      }
    });

    setIsVisibleChoice(false);

    sendEventToCounters({ action: 'button', label: 'back' });
  };

  return (
    <button className="btn_choice btn_control btn_back" onClick={handleClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 10L3.293 10.707L2.586 10L3.293 9.29303L4 10ZM21 18C21 18.2652 20.8946 18.5196 20.7071 18.7071C20.5196 18.8947 20.2652 19 20 19C19.7348 19 19.4804 18.8947 19.2929 18.7071C19.1054 18.5196 19 18.2652 19 18H21ZM8.293 15.707L3.293 10.707L4.707 9.29303L9.707 14.293L8.293 15.707ZM3.293 9.29303L8.293 4.29303L9.707 5.70703L4.707 10.707L3.293 9.29303ZM4 9.00003H14V11H4V9.00003ZM21 16V18H19V16H21ZM14 9.00003C15.8565 9.00003 17.637 9.73753 18.9497 11.0503C20.2625 12.363 21 14.1435 21 16H19C19 14.6739 18.4732 13.4022 17.5355 12.4645C16.5978 11.5268 15.3261 11 14 11V9.00003Z"
          fill="white"
        />
      </svg>

      <span>На шаг назад</span>
    </button>
  );
};
